<template>
  <div class="container about">
    <div class="row">
      <div class="col-12 justify-content-center">
        <h1 class="title display-2">{{$t('title')}}</h1>
      </div>
      <card v-for="person in people" v-bind:key="person.name" :person="person"></card>
    </div>
  </div>
</template>

<i18n>
en:
  title: The Team
de:
  title: Das Team
</i18n>

<script>
import Vue from 'vue';
import Card from '@/components/Card';

export default {
  name: 'Team',
  components: {
    card: Card,
  },
  data() {
    return {

    };
  },
  asyncComputed: {
    people: function people() {
      return Vue.http.get(`static/team/locales/${this.$i18n.locale}/team.json`)
        .then(response => response.data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about {
  padding-bottom: 150px;
}

.row {
  text-align: center;
}

h1.title {
  margin-top: 50px;
  text-align: center;
  padding-left: 50px;
  padding-right: 50px;
  min-height: 50px;
  margin-bottom: 50px;
}

h2 {
  padding-left: 100px;
  padding-right: 100px;
}

p.about-us {
  padding-left: 100px;
  padding-right: 100px;
}

@media (max-width: 581.99px) {
  h1.title {
    font-size: 2.5rem;
    padding: 0;
  }

  h2 {
    font-size: 1.5rem;
    padding: 0;
  }

  p.about-us {
    padding-left: 0px;
    padding-right: 0px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Team.vue